<template>
  <div class="wrap talk">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification">
					<section class="txt tit">
						<h1>개인정보 수집 처리내역</h1>
					</section>
					<section>
						<div class="box privacy">
							<span>민팃(주)는 [개인정보보호법] 제 20조 제1항에 따라 고객님의 개인정보 수집 처리내역을 안내 드립니다.</span>
							<ul>
								<li>개인정보의 수집 출처 : {{allianceNm}} </li>								
								<li>수집처 : 민팃(주)</li>
								<li>개인정보의 이용 목적:
									<ol>
										<li>회원제 서비스 이용에 따른 본인 확인 절차</li>
										<li>중고 {{prdNm}} 거래 서비스 제공</li>
										<li>고객상담, 고객불만 접수 및 처리</li>
										<li>약관변경 등 고지사항의 전달 및 안내</li>
										<li>회원서비스 이용에 대한 동계 분석</li>
									</ol>
								</li>
							</ul>
							<span>고객님께서는 언제든지 개인정보 처리정지 요청을 하실 수 있으며, 처리정지를 원하실 경우 아래 고객센터로 연락 주시기 바랍니다. 감사합니다.</span>
						</div>
					</section>
				</article>
				<div class="cs-center row row_ac row_jsc b-cs">
					<span class="qa">고객센터 문의 </span>
					<span><a href="#" class="en phone">1877-5446</a></span>
				</div>
			</main>
		</div>
	</div>
</template>


<script>

import Vue from 'vue'
import AppConfig from '@/config'
import Utils from '@/modules/utils'


const $ = window.$

export default {
  name: 'IndvInfoPrcsPrts',
  components: {
  },
  data: () => ({

    AppConfig: AppConfig,
	allianceNm: "",
	prdNm : ""
  }),
  computed: {

  },
  mounted() {

	this.allianceNm = this.$route.query.allianceNm      
	this.prdNm 		= this.$route.query.prdNm      

  },

  methods: {


  }
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/IndvInfoPrcsPrts.vue